import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { TALENT_DOCKER_API_URL } from "../../../constants";
export function fetcher(_x, _x2) {
  return _fetcher.apply(this, arguments);
}
function _fetcher() {
  _fetcher = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, fetchOptions) {
    var ENDPOINT, response, errorData, text, isEmpty, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          ENDPOINT = TALENT_DOCKER_API_URL;
          _context.prev = 1;
          _context.next = 4;
          return fetch("".concat(ENDPOINT).concat(url), _objectSpread({
            headers: _objectSpread({
              'Content-Type': 'application/json'
            }, (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.headers) || {}),
            body: fetchOptions !== null && fetchOptions !== void 0 && fetchOptions.body ? JSON.stringify(fetchOptions.body) : undefined
          }, fetchOptions));
        case 4:
          response = _context.sent;
          if (response.ok) {
            _context.next = 10;
            break;
          }
          _context.next = 8;
          return response.json();
        case 8:
          errorData = _context.sent;
          throw new Error("".concat(errorData.error, " ").concat(errorData.status, ": ").concat(errorData.message));
        case 10:
          _context.next = 12;
          return response.text();
        case 12:
          text = _context.sent;
          isEmpty = text.trim().length === 0;
          if (!isEmpty) {
            _context.next = 16;
            break;
          }
          return _context.abrupt("return", response.status);
        case 16:
          data = JSON.parse(text);
          return _context.abrupt("return", data);
        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](1);
          if (!(_context.t0 instanceof Error)) {
            _context.next = 26;
            break;
          }
          throw new Error("Error fetching data: ".concat(_context.t0.message));
        case 26:
          throw new Error("Error fetching data: Unknown error");
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 20]]);
  }));
  return _fetcher.apply(this, arguments);
}